import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserDeactivetedFormComponent } from '@shared/components/forms/user-deactiveted-form/user-deactiveted-form.component';
import { ShowHidePasswordComponent } from '@shared/components/show-hide-password/show-hide-password.component';
import { TableStudentEsdpResultComponent } from '@shared/components/table-student-esdp-result/table-student-esdp-result.component';
import { ActionButtonOrLinkModule } from '@shared/components/UI/action-button-or-link/action-button-or-link.module';
import { BackdropModule } from '@shared/components/UI/backdrop/backdrop.module';
import { LabelComponent } from '@shared/components/UI/label/label.component';
import { CheckPermissionsModule } from '@shared/directives/check-permissions/check-permissions.module';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgPreventCutCopyPasteModule } from 'ng-prevent-cut-copy-paste';
import { TransferringStudentsToGroupComponent } from '../courses-and-groups/group-detail/transferring-students-to-group/transferring-students-to-group';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { AddHolidaysWithGroupsSelectFormComponent } from './components/forms/add-holidays-with-groups-select-form/add-holidays-with-groups-select-form.component';
import { EventFormComponent } from './components/forms/event-form/event-form.component';
import { HolidayFormComponent } from './components/forms/holiday-form/holiday-form.component';
import { PeriodFormComponent } from './components/forms/period-form/period-form.component';
import { StudentAccessFormComponent } from './components/forms/student-access-form/student-access-form.component';
import { StudentNoteEditComponent } from './components/forms/student-note-edit/student-note-edit.component';
import { StudentNoteFormComponent } from './components/forms/student-note-form/student-note-form.component';
import { StudentNoteViewComponent } from './components/forms/student-note-view/student-note-view.component';
import { StudentWorkNoteFormComponent } from './components/forms/student-work-note-form/student-work-note-form.component';
import { TextFieldFormComponent } from './components/forms/text-field-form/text-field-form.component';
import { TransferGroupToEsdpFormComponent } from './components/forms/transfer-group-to-esdp-form/transfer-group-to-esdp-form.component';
import { FroalaComponent } from './components/froala/froala.component';
import { HeaderComponent } from './components/header/header.component';
import { NotificationsListComponent } from '../profile/components/notifications/notifications-list/notifications-list.component';
import { NotificationsComponent } from '../profile/components/notifications/notifications.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { TableStudentFinalResultsComponent } from './components/table-student-final-results/table-student-final-results.component';
import { TableStudentResultsComponent } from './components/table-student-results/table-student-results.component';
import { AnimatedLogoComponent } from './components/UI/animated-logo/animated-logo.component';
import { ButtonWithProgressComponent } from './components/UI/button-with-progress/button-with-progress.component';
import { CardComponent } from './components/UI/card/card.component';
import { CheckboxListComponent } from './components/UI/checkbox-list/checkbox-list.component';
import { ConfirmDialogComponent } from './components/UI/confirm-dialog/confirm-dialog.component';
import { DropdownListIconComponent } from './components/UI/dropdown-list-icon/dropdown-list-icon.component';
import { FormDialogComponent } from './components/UI/form-dialog/form-dialog.component';
import { InfoDialogComponent } from './components/UI/info-dialog/info-dialog.component';
import { InputGroupComponent } from './components/UI/input-group/input-group.component';
import { InputRadioComponent } from './components/UI/input-radio/input-radio.component';
import { LinksListItemComponent } from './components/UI/links-list-item/links-list-item.component';
import { LoaderComponent } from './components/UI/loader/loader.component';
import { ModalComponent } from './components/UI/modal/modal.component';
import { PageComponent } from './components/UI/page/page.component';
import { RoutingTabsComponent } from './components/UI/routing-tabs/routing-tabs.component';
import { SearchFieldAutocompleteComponent } from './components/UI/search-field-autocomplete/search-field-autocomplete.component';
import { SearchFieldComponent } from './components/UI/search-field/search-field.component';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { AnonymousGuard } from './guards/anonymous/anonymous.guard';
import { AuthGuard } from './guards/auth/auth.guard';
import { ReplaceWhitespacesPipe } from './pipes/replase-whitespaces/replace-whitespaces.pipe';
import { DisableInteractionsDirective } from '@shared/directives/disable-interactions/disable-interactions.directive';
import { DatePickerComponent } from '../components/date-picker/date-picker.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AlertComponent } from '../components/alert/alert.component';

@NgModule({
  exports: [
    NgbModule,
    FontAwesomeModule,
    AutocompleteLibModule,
    FormsModule,
    ReactiveFormsModule,
    AnimatedLogoComponent,
    HeaderComponent,
    CommonModule,
    LoaderComponent,
    ConfirmModalComponent,
    ReplaceWhitespacesPipe,
    ClickOutsideDirective,
    PaginationComponent,
    RoutingTabsComponent,
    PageComponent,
    CardComponent,
    LinksListItemComponent,
    InputGroupComponent,
    InputRadioComponent,
    LabelComponent,
    DropdownListIconComponent,
    ButtonWithProgressComponent,
    SearchFieldComponent,
    FroalaComponent,
    SearchFieldAutocompleteComponent,
    TableStudentResultsComponent,
    TableStudentFinalResultsComponent,
    SearchFieldAutocompleteComponent,
    NotificationsComponent,
    ModalComponent,
    ShowHidePasswordComponent,
    TableStudentEsdpResultComponent,
    DisableInteractionsDirective,
  ],
  declarations: [
    AnimatedLogoComponent,
    HeaderComponent,
    LoaderComponent,
    ConfirmModalComponent,
    NotificationsComponent,
    ClickOutsideDirective,
    ReplaceWhitespacesPipe,
    NotificationsListComponent,
    PaginationComponent,
    RoutingTabsComponent,
    PageComponent,
    CardComponent,
    LinksListItemComponent,
    InputGroupComponent,
    InputRadioComponent,
    CheckboxListComponent,
    LabelComponent,
    DropdownListIconComponent,
    FormDialogComponent,
    ButtonWithProgressComponent,
    ConfirmDialogComponent,
    TransferringStudentsToGroupComponent,
    SearchFieldComponent,
    PeriodFormComponent,
    EventFormComponent,
    HolidayFormComponent,
    FroalaComponent,
    StudentNoteFormComponent,
    UserDeactivetedFormComponent,
    SearchFieldAutocompleteComponent,
    StudentAccessFormComponent,
    StudentWorkNoteFormComponent,
    TableStudentResultsComponent,
    TableStudentEsdpResultComponent,
    TableStudentFinalResultsComponent,
    TextFieldFormComponent,
    ModalComponent,
    ShowHidePasswordComponent,
    StudentNoteViewComponent,
    StudentNoteEditComponent,
    TransferGroupToEsdpFormComponent,
    AddHolidaysWithGroupsSelectFormComponent,
    InfoDialogComponent,
    DisableInteractionsDirective,
  ],
  imports: [
    FontAwesomeModule,
    CheckPermissionsModule,
    NgbModule,
    CommonModule,
    AutocompleteLibModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatListModule,
    MatDatepickerModule,
    MatTooltipModule,
    FroalaEditorModule,
    FroalaViewModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatIconModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSlideToggleModule,
    BackdropModule,
    ActionButtonOrLinkModule,
    NgPreventCutCopyPasteModule,
    MatMenuModule,
    DatePickerComponent,
    TooltipModule,
    AlertComponent,
  ],
  providers: [AnonymousGuard, AuthGuard],
})
export class SharedModule {}
